import React, { useEffect } from "react";
import CategoriesBar from "../../../globalcomponents/navbar/categorieslist/CategoriesBar";
import Navbar from "../../../globalcomponents/navbar/Navbar";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { getKeepShopping } from "../../../../Redux/ActivityApi/slice";

const dummyProducts = [
  { img: "../../assets/img/products/product-2.png" },
  { img: "../../assets/img/products/product-3.png" },
  { img: "../../assets/img/products/product-4.png" },
  { img: "../../assets/img/products/product-5.png" },
  { img: "../../assets/img/products/product-6.png" },
  { img: "../../assets/img/products/product-7.png" },
  { img: "../../assets/img/products/product-11.png" },
  { img: "../../assets/img/products/product-12.png" },
  { img: "../../assets/img/products/product-14.png" },
  { img: "../../assets/img/products/product-15.png" },
  { img: "../../assets/img/products/product-16.png" },
  { img: "../../assets/img/products/product-18.png" },
].map((item) => ({
  _id: "",
  mainImage: item.img,
  name: "Dolce & Gabbana's 'Greta' tote has been crafted in Italy from hard-wearing red textured-leather.",
  brand: "Dolce & Gabbana",
  rating: "4.0",
  price: "1,549",
  mrp: "2800.00",
  discount: "36%Off",
}));

const BrowserHistory = () => {
  const dispatch = useAppDispatch();
  const { keepShopping } = useAppSelector((state) => state.activity);

  useEffect(() => {
    dispatch(getKeepShopping());
  }, [dispatch]);

  const productsToDisplay = keepShopping && keepShopping.length > 0
    ? keepShopping.map((item) => ({
        _id: item._id,
        mainImage: item.mainImage,
        name: item.name,
        brand: "Salar Store",
        rating: "4.5",
        price: "1,549",
        mrp: "2800.00",
        discount: "36%Off",
      }))
    : dummyProducts;

  return (
    <>
      <div className=" display-max">
        <Navbar />
        <CategoriesBar />
        <div className=" p-3">
          <h5 className=" text-black fs-style-2">Your Browsing History</h5>
          <div className=" mt-n2">
            <b className=" text-black fw-normal text-xs">
              These items were viewed recently. We use them to personalise
              recommendations.
            </b>
          </div>
          <div className=" d-flex row justify-content-start align-items-stretch mt-4 mb-3 flex-wrap">
            {productsToDisplay.map((product, index) => (
              <div className="col-2 mb-4" key={product._id || index}>
                <div className="card border border-radius-lg p-2 px-1 h-100 shadow-none d-flex flex-column justify-content-between">
                  <a href={product._id ? `/DetailPage/${product._id}` : "/DetailPage"}>
                    <div className="card-header p-0 position-relative border-radius-lg z-index-2 bg-gray">
                      <div className="d-block blur-shadow-image">
                        <span className=" badge badge-xs bg-gray-400 border-radius-2xl text-white ms-1">
                          Exclusive
                        </span>
                        <img
                          src={product.mainImage}
                          alt={product.name}
                          className="img-fluid-max-screens p-3"
                          style={{ height: "180px", objectFit: "contain" }}
                          loading="lazy"
                          onError={(e) => { e.currentTarget.src = "/assets/img/salarlogo.png"; }}
                        />
                        <div className="offer-text justify-content-end">
                          <div className="icon bg-white icon-shape border rounded-circle text-center">
                            <i className="bi bi-heart opacity-5 text-lg"></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <div className="p-2 text-start lh-0 d-flex flex-column justify-content-between flex-grow-1">
                    <div>
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <b className="font-weight-bold mt-1 mb-1">
                            <a href={product._id ? `/DetailPage/${product._id}` : "/DetailPage"}>{product.brand}</a>
                          </b>
                        </div>
                        <div>
                          <span className="text-black text-xs">
                            <i className="bi bi-star-fill me-1 text-xxs"></i>{product.rating}
                          </span>
                        </div>
                      </div>
                      <div className=" mt-1">
                        <div className=" lh-1">
                          <b className="mt-2 fw-normal text-xxs text-black" style={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                            {product.name}
                          </b>
                        </div>
                      </div>
                    </div>
                    <div className="mt-3">
                      <div className=" d-flex justify-content-between align-items-center mb-2 px-2">
                        <div>
                          <b className="font-bold fs-5 text-black my-auto">
                            <sup className=" fw-normal">₹</sup>{product.price}{" "}
                            <sub>
                              <b className="fw-normal text-black text-xxs">MRP: </b>{" "}
                              <b className="fw-normal text-black text-xxs text-decoration-line-through">
                                {product.mrp}
                              </b>
                              <b className="fw-bold text-danger text-xs ms-1">
                                ({product.discount}){" "}
                              </b>
                            </sub>
                          </b>
                        </div>
                      </div>
                      <div className=" text-center">
                        <button className=" btn btn-md w-95 fw-bolder text-black btn-outline-dark">
                          Remove from view
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className=" display-mini display-mob"></div>
    </>
  );
};

export default BrowserHistory;
